<div id="segments" class="d-flex flex-column">
  <div id="profileText" class="profile-text" *ngIf="presentPage === profilePage">
    <div id="profileNameTitle" class="profile-name-title">{{profileNameValue}}</div>
    <h2 class="profile-name-text">{{profileDataSet?.profileName}}</h2>
  </div>
  <div id="livePreview" class="al_live_preview" [ngClass]="tabIndex === 2 || tabIndex === 3 || tabIndex === 4 ? 'preview_padding' : ''">
    <!-- Live preview - temporarly image -->
    <iposcen-live-preview  [sidenav]="pageType" *ngIf="tabIndex === 2 || tabIndex === 3 || tabIndex === 4  "></iposcen-live-preview>
    <iposcen-content-live-preview [sidenav]="pageType" [segmentspresentPage] = "presentPage"
      *ngIf="tabIndex === 1 || (tabIndex === 0 && presentPage === profilePage)">
    </iposcen-content-live-preview>
    <!-- Layout of preview -->
    <div id="layout" class="preview_layout" *ngIf="tabIndex === 2 || tabIndex === 3 || tabIndex === 4">
      <div *ngIf="showPreviewLayout">
        <div id="LCG1" class="card">
          <img
            src="{{segmentLayout === 1 ?  'assets/images/prev_layout_selected_1.svg': 'assets/images/prev_layout_1.svg'}}"
            alt="layout 1" (click)="setLayout(1)" class="cursor-pointer" />
        </div>
        <div id="LCG2" class="card">
          <img
            src="{{segmentLayout === 2 ?  'assets/images/prev_layout_selected_2.svg': 'assets/images/prev_layout_2.svg'}}"
            alt="layout 2" (click)="setLayout(2)" class="cursor-pointer" />
        </div>
        <div id="LCG3" class="card">
          <img
            src="{{segmentLayout === 3 ?  'assets/images/prev_layout_selected_3.svg': 'assets/images/prev_layout_3.svg'}}"
            alt="layout 3" (click)="setLayout(3)" class="cursor-pointer" />
        </div>
      </div>
    </div>
  </div>

  <ul *ngIf="(tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4)" class="nav nav-tabs"
    role="tablist">
    <li class="nav-item">
      <a class="nav-link gtmAssetLibrarySegmentTitle" data-toggle="tab" [ngClass]="{'active': tabIndex === 1}"
        (click)="navigate()"><span placement="top" container='body'
          ngbTooltip="{{editCheck?showSegmentName + details:newSegmentTitle}}">{{editCheck?
          tabTrimString(showSegmentName): tabTrimString(newSegmentTitle)}}</span></a>
    </li>
    <li class="nav-item" *ngIf="pages && pages.page1">
      <a class="nav-link gtmAssetLibrarySegmentPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 2}"
        (click)="clickable?setIndex(2):false">
        <span i18n="@@global.tab-nav.page1">PAGE 1</span>

        <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
        <!-- <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page1">PAGE 1</span>&nbsp;</div>
          <div class="delete_page" *ngIf="pagelen > 1" (click)="clickable?openPopupSeg(delete,0):false"></div>
        </div> -->
      </a>
    </li>
    <li class="nav-item" *ngIf="pages && pages.page2">
      <a class="nav-link gtmAssetLibrarySegmentPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
        (click)="clickable?setIndex(3):false">
        <span i18n="@@global.tab-nav.page2">PAGE 2</span>

        <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
        <!-- <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page2">PAGE 2</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupSeg(delete,1):false"></div>
        </div> -->
      </a>
    </li>
    <li class="nav-item" *ngIf="pages && pages.page3">
      <a class="nav-link gtmAssetLibrarySegmentPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
        (click)="clickable?setIndex(4):false">
        <span i18n="@@global.tab-nav.page3">PAGE 3</span>

        <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
        <!-- <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page3">PAGE 3</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupSeg(delete,2):false"></div>
        </div> -->
      </a>
    </li>
    <li class="nav-item" *ngIf="clickable && !checkPages()">
      <a class="nav-link gtmAssetLibrarySegmentAddPage" data-toggle="tab" (click)="addPage()">
        <img class="add-page" alt="add pages" />
      </a>
    </li>
    <li class="nav-item exit_preview" *ngIf="pages && pages.page1">
      <a class="nav-link gtmAssetLibrarySegmentCancel" (click)="cancel()">
        <img class="exit-without-change" alt="exit without changes" />
      </a>
    </li>
  </ul>


  <section *ngIf="tabIndex === 0" class="main_section al_storelogo">
    <div id="segmentsMainSec" class="d-flex flex-column h-100">
      <div id="segmentsMainSecHeaders" class="main_section_headers" [ngClass]="presentPage === profilePage? 'profile_main_section_headers':''">
        <svg _ngcontent-mkp-c137="" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
          *ngIf="presentPage === assetsPage" xmlns="http://www.w3.org/2000/svg">
          <path _ngcontent-mkp-c137="" fill-rule="evenodd" clip-rule="evenodd"
            d="M23.0319 3.969C23.1018 4.03867 23.1572 4.12143 23.195 4.21255C23.2328 4.30367 23.2523 4.40135 23.2523 4.5C23.2523 4.59865 23.2328 4.69633 23.195 4.78745C23.1572 4.87857 23.1018 4.96133 23.0319 5.031L12.5319 15.531C12.4623 15.6008 12.3795 15.6563 12.2884 15.6941C12.1973 15.7319 12.0996 15.7513 12.0009 15.7513C11.9023 15.7513 11.8046 15.7319 11.7135 15.6941C11.6224 15.6563 11.5396 15.6008 11.4699 15.531L6.96995 11.031C6.90022 10.9613 6.8449 10.8785 6.80716 10.7874C6.76942 10.6963 6.75 10.5986 6.75 10.5C6.75 10.4014 6.76942 10.3037 6.80716 10.2126C6.8449 10.1215 6.90022 10.0387 6.96995 9.969C7.03968 9.89927 7.12246 9.84395 7.21357 9.80621C7.30468 9.76847 7.40233 9.74905 7.50095 9.74905C7.59956 9.74905 7.69721 9.76847 7.78832 9.80621C7.87943 9.84395 7.96222 9.89927 8.03195 9.969L12.0009 13.9395L21.9699 3.969C22.0396 3.89915 22.1224 3.84374 22.2135 3.80593C22.3046 3.76812 22.4023 3.74866 22.5009 3.74866C22.5996 3.74866 22.6973 3.76812 22.7884 3.80593C22.8795 3.84374 22.9623 3.89915 23.0319 3.969Z">
          </path>
          <path _ngcontent-mkp-c137="" fill-rule="evenodd" clip-rule="evenodd"
            d="M12 3.75005C10.3683 3.75005 8.77326 4.2339 7.41656 5.14042C6.05985 6.04694 5.00243 7.33542 4.37801 8.84291C3.75358 10.3504 3.59021 12.0092 3.90854 13.6095C4.22686 15.2099 5.0126 16.6799 6.16638 17.8337C7.32017 18.9875 8.79018 19.7732 10.3905 20.0915C11.9909 20.4099 13.6497 20.2465 15.1572 19.6221C16.6646 18.9976 17.9531 17.9402 18.8596 16.5835C19.7662 15.2268 20.25 13.6317 20.25 12C20.25 11.8011 20.329 11.6104 20.4697 11.4697C20.6103 11.3291 20.8011 11.25 21 11.25C21.1989 11.25 21.3897 11.3291 21.5303 11.4697C21.671 11.6104 21.75 11.8011 21.75 12C21.7497 14.1463 21.0413 16.2325 19.7345 17.9351C18.4278 19.6377 16.5958 20.8615 14.5226 21.4168C12.4494 21.9721 10.2509 21.8278 8.26813 21.0063C6.28531 20.1848 4.62896 18.732 3.55595 16.8733C2.48294 15.0145 2.05324 12.8536 2.33349 10.7257C2.61373 8.59782 3.58826 6.62186 5.10594 5.10428C6.62362 3.5867 8.59964 2.61229 10.7275 2.33219C12.8554 2.05208 15.0163 2.48192 16.875 3.55505C16.9646 3.60193 17.0439 3.66646 17.1079 3.74476C17.1719 3.82306 17.2195 3.9135 17.2477 4.01064C17.2759 4.10779 17.2841 4.20963 17.2719 4.31005C17.2597 4.41046 17.2273 4.50737 17.1767 4.59494C17.1261 4.68252 17.0583 4.75894 16.9773 4.81963C16.8964 4.88032 16.8041 4.92401 16.7058 4.94807C16.6076 4.97214 16.5055 4.97608 16.4056 4.95966C16.3058 4.94325 16.2104 4.90681 16.125 4.85255C14.8714 4.12758 13.4482 3.74721 12 3.75005Z">
          </path>
        </svg>
        <span i18n="@@segments.main-section-headers.segments">SEGMENTS</span>
        <span class="data_action" *ngIf="presentPage === profilePage && displaySegmentGroups?.length">
          <button type="button" id="uploadLogo"
            class="btn btn-primary btn-sm left_icon_btn gtmAssetLibrarySegmentNewSegmentGroup" (click)="addSegment()">
            <img class="add-new" alt="add new" />
            <span i18n="@@segments.main-section-headers.new-segment">New Segment Group</span>
          </button>
        </span>
      </div>

      <!-- Data header with info like no. of content groups, action buttons and filters -->
      <div id="segmentsDataHeader" class="data_header" [ngClass]="(displaySegmentGroups.length > 0)?'':'display-block'">
        <span *ngIf="presentPage === assetsPage && displaySegmentGroups?.length > 0">
          <span *ngIf="displaySegmentGroups" id="dataTitle">{{displaySegmentGroups?.length}}
            {{segmentHeading}}
          </span>
          <span *ngIf="displaySegmentGroups?.length > 1">
            <span class="sort-by-label" i18n="@@segments.segment-content.sort-by">Sort by</span>:&nbsp;
            <div id="segmentDropDown" ngbDropdown class="d-inline-block">
              <button ngbDropdownToggle class="btn btn-primary btn-sm dropdown-toggle" id="sortDropDown">{{sortValue}}
              </button>
              <div id="segmentDropDownMenu" ngbDropdownMenu aria-labelledby="sortDropDown">
                <button ngbDropdownItem *ngIf="sortValue!= segmentName" (click)="sortBy('segmentName')">
                  <span>{{segmentName}}</span></button>
                <button ngbDropdownItem *ngIf="sortValue!=retailerName" (click)="sortBy('retailerName')">
                  <span>{{retailerName}}</span></button>
              </div>
            </div>
          </span>
        </span>
        <span *ngIf="presentPage === assetsPage && displaySegmentGroups?.length === 0"
          i18n="@@segments.segment-content.create-device-segments">Create device segments to help with the sales
          process.
          Every segment is associated with a color.</span>

        <ng-container *ngIf="presentPage === profilePage && !displaySegmentGroups?.length">
          <div id="cpSegmentHead" class="cpSegmentHead">
            <span i18n="@@segments.segment-content.add-segments-to-help-sales">Add Segments to help the sales process by
              grouping and categorizing devices based on their performance level, device type, etc.</span><br />
            <strong><span i18n="@@segments.segment-content.no-segment-group-created">No Segment Group has been
                created.</span></strong>
          </div>
        </ng-container>
        <div id="segmentaddToPckg" *ngIf="displaySegmentGroups?.length > 0 && presentPage === profilePage">
          <strong><span i18n="@@segments.segment-content.add-package">Added to Package</span>:</strong>
          {{ selctedContGrpsForProfile?.contentGrps?.length || '0'}}
          <span i18n="@@segments.segment-content.add-package-segments">Segments</span>
          <br />
          <strong><span i18n="@@segments.segment-content.show-on-device">Show on Device</span>:</strong>
          {{ selctedContGrpsForProfile?.showOnDevice ? '1' : '0'}}
          <span i18n="@@segments.segment-content.show-on-device-segment">Segment</span>
        </div>
        <span class="data_action"
          *ngIf="presentPage === assetsPage || (presentPage === profilePage && !displaySegmentGroups?.length)">
          <button type="button" id="uploadLogo"
            class="btn btn-primary btn-sm left_icon_btn gtmAssetLibrarySegmentNewSegmentGroup" (click)="addSegment()">
            <img class="add-new" alt="add new" />
            <span i18n="@@segments.button.new-segment-group">New Segment Group</span>
          </button>
        </span>
      </div>

      <div id="cpSegmentSec" *ngIf="presentPage === profilePage">
        <div id="cpSegmentHead1" class="cpSegmentHead" *ngIf="displaySegmentGroups?.length">
          <span i18n="@@segments.segment-content.select-device-segment">Select device segments for this profile to
            help with the sales process.
            Every segment is associated with a color.</span><br />
          <!-- <span i18n="@@segments.segment-content.no-of-segment">
              You may <strong>add up to 10 segments.</strong>
              </span> -->
          <strong><span i18n="@@segments.segment-content.no-of-segment">You may add up to 10
              segments.</span></strong>
        </div>
      </div>

      <!-- Data Content -->
      <div id="dataSegments" class="data_content segments_only" *ngIf="displaySegmentGroups?.length > 0"
        [ngClass]="presentPage === profilePage?'acc_table_view':''">
        <div id="showOnDeviceSelect" class="show_on_device_select" *ngIf="presentPage === profilePage">
          <div id="showOnDeviceLabel" class="small_text border-right shown-on-device-label"><span i18n="@@segments.shown-on-device-label">Show
              on Device</span></div>
          <div><span i18n="@@segments.content-groups-label">Content Groups</span></div>
        </div>
        <div class="accordion" id="logoContentAccordian">
          <!-- Group 1 -->
          <div id="logoContentCard" class="card" *ngIf="presentPage === profilePage">
            <div id="logoContentCardBottom" class="card card_bottom">
              <div id="segmentOne" class="card-header none_text">
                <div id="segmentAccCheck" class="acc_check">
                  <div id="segmentRadio" class="form-check">
                    <input type="radio" name="cpLCGSelect" class="form-check-input" value="isSegmentNone"
                      [checked]="isSegmentNone" (change)="removeShowonDevice()">
                  </div>
                </div>
                <div id="segmentCardHeader" class="card-header-content">
                  <div id="segmentDataSec" class="d-flex">
                    <div id="segmentSelect" class="select_none">
                      <span i18n="@@hero-tile.asset-library.none">None</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="segmentCard" class="card"
            *ngFor="let segmentGroup of displaySegmentGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
            <div id="segmentCardHeader" class="card-header small_text" id="segmentOne">
              <div id="segmentAccCheck2" class="acc_check" *ngIf="presentPage === profilePage">
                <div id="segmentRadio" class="form-check" [ngbPopover]="(!segmentGroup?.addToPackage) ? showonDeviceDisabled:''"
                  [placement]="changePlacement == true ? 'left' : 'right'" triggers="mouseenter:mouseleave">
                  <input type="radio" name="cpLCGSelect" class="form-check-input" [value]="segmentGroup?.showOnDevice"
                    [checked]="segmentGroup?.showOnDevice" (change)="addToProfile($event,segmentGroup?.index,'radio')"
                    [disabled]="!segmentGroup?.addToPackage" />
                </div>
              </div>
              <div id="segmentCardHeaderContent" class="card-header-content">
                <div id="segmentTitle" class="title_left">
                  <div id="segmentGrpData" class="d-flex">
                    <div id="segmentColor" class="segment_color_badge" [style.background]="segmentGroup?.configurations?.segmentBgColor">
                    </div>
                    <div id="publishedName" class="title">
                      <span>{{segmentGroup?.configurations?.publishedName}} &nbsp;&nbsp;</span>
                    </div>
                  </div>
                  <div class="d-flex">
                  <div *ngIf="(segmentGroup.isContentExpires)" id="contentExpire" class="content-expire"><img class="contents-info-icon" alt="info_icon"><span>{{globConst.CONT_GRP_EXPIRED_TEXT}}</span></div>
                  <div id="segmentGroupBtn" class="d-flex"
                    *ngIf="presentPage === assetsPage && ((!segmentGroup.islocked && isStoreUser) || !isStoreUser)">
                    <button type="button" placement="bottom" ngbTooltip={{edit}} (click)="editSegment(segmentGroup?.id)"
                      class="btn gtmEditSegment">
                      <img alt="Edit" />
                    </button>
                    <button type="button" placement="bottom" ngbTooltip={{tooltipDelete}}
                      (click)="openDeleteModal(segmentGroup?.id)" class="btn gtmDeleteSegment">
                      <img alt="Delete" />
                    </button>
                    <iposcen-delete-popup #deleteModal [contentName]="segmentToDeleteName"
                      [buttonName]="'Content Group'" (delete)="deleteSegment(segmentToDelete)">
                    </iposcen-delete-popup>
                    <button type="button" *ngIf="isRetailerUser || isRegionalHQ"
                      (click)="openSendSegmentToAccountModal(segmentGroup?.id)" class="btn gtmSendSegment gtmSendBtn"
                      placement="bottom" ngbTooltip={{tooltipSendtoStores}} container="body">
                      <img alt="Send" />
                    </button>
                  </div>
                  </div>
                </div>
                <div id="otherData" class="other_data">
                  <div id="assetIDCopy">
                    <iposcen-assetid-copy [assetID]="segmentGroup?.id" *ngIf="presentPage === assetsPage">
                    </iposcen-assetid-copy>
                    <div id="assetIDSubTitle" class="subtitle_group">
                      <span class="subtitle" *ngIf="presentPage === profilePage"><span
                          i18n="@@segments.data-content.created-by">Created By</span>:
                        {{segmentGroup?.createdByUser}}
                      </span>
                      <span class="subtitle"><span i18n="@@segments.data-content.last-edited-by">Last Edited By</span>
                        {{segmentGroup?.createdByUser}}:
                        {{segmentGroup?.updateTime | dateFormat: "changeToLocalTimeZone"}}
                      </span>
                      <span class="subtitle" *ngIf="presentPage === assetsPage && userRole !== 'nonConnectedUser'"><span
                          i18n="@@segments.data-content.push-all">Pushed to all
                          devices</span>:
                        {{segmentGroup?.ispushedToDevice ? 'Y' : 'N'}}
                      </span>
                    </div>

                    <div id="segmentGroupCheckbox" class="form-check mt-3" *ngIf="presentPage === profilePage"
                      [ngbPopover]="(selctedContGrpsForProfile?.contentGrps?.length === 10 && !segmentGroup?.addToPackage)?addToPackageLimit:''"
                      placement="top-left" triggers="mouseenter:mouseleave">
                      <input class="form-check-input" type="checkbox" [value]="segmentGroup?.addToPackage"
                        [checked]="segmentGroup?.addToPackage"
                        (change)="addToProfile($event,segmentGroup?.index,'check')"
                        [disabled]="selctedContGrpsForProfile?.contentGrps?.length === 10 && !segmentGroup?.addToPackage"
                        id="addToPackOne" />
                      <label class="form-check-label" for="addToPackOne">
                        <span i18n="@@segments.data-content.add-to-pack">Add to Package</span>
                      </label>
                    </div>
                  </div>
                  <div id="gtmlockIcon" class="d-flex" *ngIf="presentPage === assetsPage && segmentGroup.islocked && isStoreUser">
                    <div id="gtmlock" class="gtmlockIcon lock-icon">
                      <img alt="content locked" /> 
                      <span class="pl-1 pt-1">{{lockContentText}}</span>
                    </div>
                  </div>
                  <div id="customControl" class="custom-control custom-switch"
                    *ngIf="(presentPage === assetsPage) && (userRole === retailHqUser || userRole === regionalHqUser)">
                    <input type="checkbox" class="custom-control-input" [id]="'lockContent'+segmentGroup?.id"
                      [checked]="segmentGroup?.islocked" [value]="segmentGroup?.islocked"
                      (click)=changeLockContentStatus(segmentGroup?.id,$event,segmentGroup) />
                    <label class="custom-control-label" [for]="'lockContent'+segmentGroup?.id">
                      <span i18n="@@segments.data-content.lock-content">Lock Content</span>
                    </label>
                  </div>
                </div>
              </div>
              <div id="collapseLink" class="collapse_link collapsed collapse-button {{segmentGroup?.id}}" type="button"
                (click)="getDetailsOfSegment(segmentGroup?.id)"
                [ngClass]="segmentGroup.isExpanded ? 'transform-180' : ''">
                <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                </svg>
              </div>
            </div>
            <div id="collapseThree" class="collapse" #collapse="ngbCollapse" [(ngbCollapse)]="!segmentGroup.isExpanded"
              aria-labelledby="logoCGThree" data-parent="#logoContentAccordian">
              <div id="segmentsCardBody" class="card-body" [ngClass]="presentPage === profilePage?'':'card-body-asset'">
                <div id="segmentsTable" class="table-container">
                  <table class="table-borderless" aria-describedby="segment table">
                    <tr>
                      <th scope="col">
                        <span i18n="@@segments.expanded-segment.publish-date">Publishing Date and Time</span>
                      </th>
                      <th scope="col">
                        <span i18n="@@segments.expanded-segment.expire-date">Expiration Date and Time</span>
                      </th>
                      <th scope="col">
                        <span i18n="@@segments.expanded-segment.retail-name">Retailer Name</span>
                      </th>
                    </tr>
                    <tr>
                      <td>
                        {{segmentGroup?. configurations?.publishTime | dateFormat: "24hrP"}}
                      </td>
                      <td>
                        {{segmentGroup?. configurations?.expireTime | dateFormat: "24hrP"}}
                      </td>
                      <td class="segment-retailer-name-column">
                        {{segmentGroup?.configurations?.retailerName}}
                      </td>
                    </tr>
                  </table>
                  <span class="duplicate-and-edit-span">
                    <button type="button"
                      class="btn btn-primary btn-sm left_icon_btn gtmAssetLibrarySegmentDuplicateAndEdit"
                      (click)="duplicateAndEditSegment(segmentGroup?.id)">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M3 2H11C11.5304 2 12.0391 2.21071 12.4142 2.58579C12.7893 2.96086 13 3.46957 13 4V14C13 14.5304 12.7893 15.0391 12.4142 15.4142C12.0391 15.7893 11.5304 16 11 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2V2ZM3 3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14V4C12 3.73478 11.8946 3.48043 11.7071 3.29289C11.5196 3.10536 11.2652 3 11 3H3Z"
                          fill="white" />
                        <path
                          d="M5 0H13C13.5304 0 14.0391 0.210714 14.4142 0.585786C14.7893 0.960859 15 1.46957 15 2V12C15 12.5304 14.7893 13.0391 14.4142 13.4142C14.0391 13.7893 13.5304 14 13 14V13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12V2C14 1.73478 13.8946 1.48043 13.7071 1.29289C13.5196 1.10536 13.2652 1 13 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2H3C3 1.46957 3.21071 0.960859 3.58579 0.585786C3.96086 0.210714 4.46957 0 5 0V0Z"
                          fill="white" />
                      </svg>
                      <span i18n="@@segments.duplicate-and-edit">Duplicate and Edit</span>
                    </button>
                  </span>
                </div>
                <!--<div class="mini-preview-container">
                                  <ng-container *ngFor="let page of segmentGroup?.configurations?.contentGroupPages">
                                      <div *ngIf="page && page.image" class="tab_dropdown_img_container">
                                        <img src={{page.image}} alt="segment" (error)="page.image = null" />
                                      </div>
                                    </ng-container>
                                </div> -->
                <div id="IdleExperiencePreviewSection" class="form-group idleExperiencePreviewSection" *ngIf="segmentGroup?.configurations?.contentGroupPages?.length" [ngClass]="isPolish ? 'moreWidth':''">
                  <form>
                    <div [ngClass]="{'width-Added-other-language': ['cs','pl'].includes(globConst.IPOS_LANGUAGE)}">
                      <input type="radio" name="ptPCGSelect" class="form-check-input" value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS
                      (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS,segmentGroup?.id)" [checked]= "globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS ==  segmentGroup.isIdleExperienceEnabled"/>
                      <label class="form-check-input" for="isIdleExperiencePreview">
                        {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IPOS}}
                      </label>
                    </div>
                    <div>
                      <input type="radio" name="ptPCGSelect" class="form-check-input" value=globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE
                      [checked]= "globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE ==  segmentGroup.isIdleExperienceEnabled"
                      (change)="togglePreviewTabs(globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE, segmentGroup?.id)" />
                      <label class="form-check-input" for="isIdleExperiencePreview">
                        {{globConst.LIVE_PREVIEW_PREVIEW_TAB_IDLE_EXPERIENCE}}
                      </label>
                    </div>
                  </form>
                </div>               
                <div id="miniPreviewContainer" class="mini-preview-container">
                  <ng-container *ngFor="let page of segmentGroup?.configurations?.contentGroupPages">
                    <!-- <div id="eachMiniPreview" class="each-mini-preview">
                      <iposcen-live-preview [data]="loadMiniPreview(segmentGroup?.id,page)" [isIdleExperienceEnable]="segmentGroup.isIdleExperienceEnabled"
                      [miniPreview]="true" [customClass]="true">
                      </iposcen-live-preview>
                    </div> -->
                    <iposcen-mini-live-preview [data]="loadMiniPreview(segmentGroup?.id,page)"
                    [isIdleExperienceEnable]="segmentGroup.isIdleExperienceEnabled"></iposcen-mini-live-preview>
                  </ng-container>
                </div>
                <div id="applicabilityTitle" class="applicability_title">
                  <span i18n="@@segments.mini-preview.content-group">Content Group Applies To</span>:
                </div>
                <div id="applicabilityRoles" class="applicability_roles">
                  <div id="segmentDevices">
                    <div id="deviceTypes"><span class="font-bold">{{deviceTypes}}</span>:
                      {{ segmentGroup?.configurations?.formFactor?.devices}}
                    </div>
                  </div>
                  <div id="segmentManufacturer">
                    <div id="manufacturer">
                      <span class="font-bold">{{manufacturers}}</span>:
                      {{ segmentGroup?.configurations?.formFactor?.manufacturer}}
                    </div>
                  </div>
                  <div id="segmentProcessors">
                    <div id="processors"><span class="font-bold">{{processors}}</span>:
                      {{ segmentGroup?.configurations?.formFactor?.processors}}
                    </div>
                  </div>
                  <div id="segementGeneration">
                    <div id="generation"><span class="font-bold">{{generation}}</span>:
                      {{ segmentGroup?.configurations?.formFactor?.generations}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <iposcen-send-to-segment-account (selectedStoreData)="getSelectedStoreData($event)" #sendToAccountModal
            [sendName]="sendNameToStore" [sendButtonName]="sendButtonText" [sendToStoreSuccess]="isSendToStore"
            (clearAllData)="isSendToStore=false">
          </iposcen-send-to-segment-account>
        </div>
      </div>

      <!-- Data Footer - Pagination -->
      <div id="dataFooter" class="data_footer">
        <nav aria-label="logo content pagination" *ngIf="displaySegmentGroups && displaySegmentGroups?.length>0">
          <ngb-pagination [collectionSize]="displaySegmentGroups?.length" [(page)]="page" [pageSize]="pageSize"
            [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false">
          </ngb-pagination>
        </nav>
      </div>
      <ng-container *ngIf="presentPage === profilePage">
        <div id="skipBtnWrapper" class="button-wrapper justify-content-end">
          <button type="button" class="btn btn-outline-primary gtmAssetLibrarySegmentSkip"
            (click)="sendToProfile('skip')">
            <span i18n="@@segments.footer.skip">Skip</span>
          </button>
          <button type="button" class="btn btn-primary gtmAssetLibrarySegmentSaveAndProceed"
            (click)="sendToProfile('send')" [disabled]="displaySegmentGroups?.length === 0">
            <span class="gtmAssetLibrarySegmentSaveAndProceed" i18n="@@logo-content.logo-content-groups.save-and-continue">Save and
              Continue</span>
          </button>
        </div>
      </ng-container>
    </div>
  </section>

  <section *ngIf="tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4"
    class="main_section al_newSegment">
    <ng-container>
      <div id="tab1" *ngIf="tabIndex === 1">
        <iposcen-create-segments [isNavigated]="isNavigated" [presentPage]="presentPage" (goBacktoSegmentContent)="setCreatedGrpID($event)">
        </iposcen-create-segments>
      </div>
      <div id="tab2" *ngIf="tabIndex === 2">
        <iposcen-page #page1 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=1
          [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoSegmentContent)="refreshSegmentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div id="tab3" *ngIf="tabIndex === 3">
        <iposcen-page #page2 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=2
          [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoSegmentContent)="refreshSegmentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div id="tab4" *ngIf="tabIndex === 4">
        <iposcen-page #page3 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=3
          [mediaObjs]="mediaObjects" [disableColors]="disableFields()" (goBacktoSegmentContent)="refreshSegmentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
    </ng-container>
    <div id="addBtnWrapper" class="button-wrapper mb-4 mr-4" style="justify-content: flex-end"
      *ngIf="tabIndex === 2 || tabIndex === 3|| tabIndex === 4">
      <button type="button" class="btn btn-outline-primary left_icon_btn" (click)="addPage()" *ngIf="!isPage3Created">
        <img class="add-page-square" alt="add page" />
        <span i18n="@@segments.button.add-page">Add Page</span>
      </button>
      <button type="button" class="btn btn-primary"
        (click)="pageError.get(1)||pageError.get(2)||pageError.get(3)?openPopup(errorPopup):updateSegment()">
        {{buttonName}}
      </button>     
      <iposcen-showon-device #showModal (show)="showOnDevice()" (closePopup)="closeShowOnDevice()">
      </iposcen-showon-device>
      <iposcen-apply-changes-to-devices #applyModal (apply)="applyToDevice(true)" (closePopup)="applyToDevice(false)">
      </iposcen-apply-changes-to-devices>
    </div>
  </section>
</div>
<!-- //popup page delete  -->
<ng-template #delete let-modal>
  <div id="confrmPopUp" class="card confirmPopup">
    <div id="modalHeader" class="modal-header">
      <div id="modalCloseIcon" (click)="modal.close()" class="close-icon">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="modalBody" class="modal-body popup-body">
      <div id="modalBodyTitle">
        <h2 class="mt-3">
          <span i18n="@@create-partner-content.delete-modal.delete-page?">Delete Page?</span>
        </h2>
        <div id="modalBodyText" class="card-desc">
          <span i18n="@@create-partner-content.delete-modal.remove-permanently">This content will be removed permanently.</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@create-partner-content.delete-modal.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="modal.close();deletePages(whichPageDelete)">
        <span i18n="@@create-partner-content.delete-modal.delete-page">Delete Page</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #errorPopup let-modal>
  <div id="confirmPopup" class="card confirmPopup">
    <div id="confirmModalHeader" class="modal-header">
      <div id="confirmClose" (click)="modal.close()" class="close-icon">
        <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="confirmModalBody" class="modal-body popup-body">
      <div id="confirmSec">
        <div id="confirmDesc" class="card-desc">
          <span *ngIf='pageError.get(1) && !pageError.get(2) && !pageError.get(3)'>{{errorMessageText}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(2)  && !pageError.get(3)'>{{errorMessageText1}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(3)  && !pageError.get(2)'>{{errorMessageText2}}</span>
          <span *ngIf='pageError.get(2) && !pageError.get(3) && !pageError.get(1)'>{{errorMessageText3}}</span>
          <span *ngIf='pageError.get(2) && pageError.get(3)  && !pageError.get(1)'>{{errorMessageText4}}</span>
          <span *ngIf='pageError.get(3) && !pageError.get(1) && !pageError.get(2)'>{{errorMessageText5}}</span>
          <span *ngIf='pageError.get(3) && pageError.get(1) && pageError.get(2)'>{{errorMessageText6}}</span>
        </div>
      </div>
    </div>
    <div id="confirmModalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close();goToErrorPage()" class="btn btn-primary btn-confirm">
        <span>{{buttonLable}}</span>
      </button>
    </div>
  </div>
</ng-template>